import { SearchState } from '../types';
import { DATA_TYPES_FOR_PARAMS } from '../searchFlyoutConfig';

export const setSearchParams = (form: SearchState) => {
  const params = new URLSearchParams();
  if (form.dataType) params.set('dataType', DATA_TYPES_FOR_PARAMS[form.dataType]);
  form.query &&
    Object.entries(form.query).forEach(([key, value]) => {
      if (value) params.set(key, value.trim());
    });
  return params.toString();
};
